/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import EmptyStates from '@/components/common/EmptyStates'
import {
  ProfessionalSkills as ProfessionalSkillsT,
} from '@/types/graphql/types'
import {
  Button,
  Title,
} from '@mantine/core'
import { useForm } from '@mantine/form'
import { useModals } from '@mantine/modals'
import useTranslation from 'next-translate/useTranslation'
import { MdAdd } from 'react-icons/md'
import PsForm from './SkillsForm'
import PSItem from './SkillsItem'

const ProfessionalSkills = ({
  professionalSkills,
  refetch,
}: {
  professionalSkills: ProfessionalSkillsT[]
  // eslint-disable-next-line react/require-default-props
  refetch?: () => void
}) => {
  const modals = useModals()
  const { t } = useTranslation('common')

  const form = useForm({
    initialValues: {
      professionalSkills,
    },
  })

  const empty = form.values.professionalSkills.length === 0

  const handleUpdatePs = ({ newPS }: { newPS: ProfessionalSkillsT[] }) => {
    form.setFieldValue('professionalSkills', newPS)
    if (refetch) refetch()
  }

  const openPsForm = () =>
    modals.openModal({
      title: t('education'),
      children: <PsForm ps={null} handleUpdatePs={handleUpdatePs} />,
    })

  return (
    <div>
      <div className="flex justify-between pt-5">
        <Title order={4}>{t('professionalSkills')}</Title>
        {!empty && (
          <Button onClick={() => openPsForm()} leftIcon={<MdAdd size={14} />}>
            {t('add')}
          </Button>
        )}
      </div>
      {!empty ? (
        form.values.professionalSkills.map(ps => (
          <PSItem key={ps.id} ps={ps} handleUpdatePs={handleUpdatePs} />
        ))
      ) : (
        <EmptyStates
          description={t('addPSMessage')}
          onClick={() => openPsForm()}
        />
      )}
    </div>
  )
}

export default ProfessionalSkills
